import React, { useEffect, useState } from "react";
import { Button, Col, Flex, Form, Row, Select } from "antd";
import { SupplierServices } from "../../../services/supplier";
import { ISuppliersByNameResponse, ISuppliersByNameResult } from "../../../interfaces/supplier";
import { CloseOutlined } from "@ant-design/icons";
import { useHasPermission } from "../../../hooks/useHasPermission";
import { PERMISSIONS } from "../../../constants/permission";
import { useParams } from "react-router-dom";

interface MappingsFormProps {
  form: any;
  initialValues: {
    mapping: string[];
  };
}

const MappingsForm: React.FC<MappingsFormProps> = ({ form, initialValues }) => {
  const { id } = useParams();
  const hasSupplierEditor = useHasPermission([PERMISSIONS.SUPPLIER_EDITOR]);
  const [suppliersByName, setSuppliersByName] = useState<ISuppliersByNameResult[]>([]);
  const fetchSuppliersByName = async () => {
    const params = {
      page: 1,
      pageSize: 5000,
    };
    try {
      const response: ISuppliersByNameResponse = await SupplierServices.getSuppliersByName({ params: params });
      const { success, data } = response;
      if (success) {
        setSuppliersByName((data.results || []).filter((d) => d.key !== id));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchSuppliersByName();
  }, []);

  return (
    <Form
      form={form}
      layout="horizontal"
      className="box-mapping"
      disabled={!hasSupplierEditor}
      initialValues={initialValues}
    >
      <Form.Item name="mapping" label="Alternative Supplier" labelCol={{ span: 7 }}>
        <Select
          showSearch
          mode="multiple"
          placeholder="Enter supplier name"
          maxTagCount={0}
          filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
          options={suppliersByName.map((item) => ({
            value: item.key,
            label: `${item.code} - ${item.label}`,
          }))}
        />
      </Form.Item>

      <Form.Item shouldUpdate noStyle>
        {() => {
          const selected: string[] = form.getFieldValue("mapping") || [];
          return selected.length > 0 ? (
            <Row className="mappings">
              <Col span={7}></Col>
              <Col span={17}>
                {selected.map((key: string) => {
                  const supplier = suppliersByName.find((s) => s.key === key);
                  return (
                    <Flex className="item" key={key} justify="space-between" align="center">
                      <span>
                        {supplier?.code} - {supplier?.label}
                      </span>
                      <Button
                        size="small"
                        icon={<CloseOutlined />}
                        onClick={() => {
                          const newValues = selected.filter((k) => k !== key);
                          form.setFieldsValue({ mapping: newValues });
                        }}
                        type="text"
                      ></Button>
                    </Flex>
                  );
                })}
              </Col>
            </Row>
          ) : null;
        }}
      </Form.Item>
    </Form>
  );
};

export default React.memo(MappingsForm);
